import { createAction } from '@reduxjs/toolkit';

import { SagaPayload, SagaPayloadwithoutRequestData } from '../api.types';
import {
  ActivateProgrammeRequest,
  CreateProgrammeRequest,
  DownloadTeamLeaderboardExcelRequest,
  SendMemberActivationCommunicationsRequest,
  UpdateProgrammeRequest,
  UploadMemberExcelRequest,
  ViewProgrammeRequest
} from './programme.types';

export const requestCreateProgramme =
  createAction<SagaPayload<CreateProgrammeRequest, string | undefined>['payload']>('request/createProgramme');

export const requestViewAllProgrammes =
  createAction<SagaPayloadwithoutRequestData['payload']>('request/viewAllProgrammes');

export const requestViewProgramme = createAction<SagaPayload<ViewProgrammeRequest>['payload']>('request/viewProgramme');

export const requestUpdateProgramme =
  createAction<SagaPayload<UpdateProgrammeRequest, string | undefined>['payload']>('request/updateProgramme');

export const requestActivateProgramme =
  createAction<SagaPayload<ActivateProgrammeRequest>['payload']>('request/activeProgramme');

export const requestDownloadTeamLeaderboardExcel = createAction<
  SagaPayload<DownloadTeamLeaderboardExcelRequest>['payload']
>('request/downloadTeamLeaderboardExcel');

export const requestSendMemberActivationCommunications = createAction<
  SagaPayload<SendMemberActivationCommunicationsRequest>['payload']
>('request/SendMemberActivationCommunications');

export const requestUploadMemberExcel =
  createAction<SagaPayload<UploadMemberExcelRequest>['payload']>('request/uploadMemberExcel');
